var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Admin',{staticStyle:{"background":"white"}},[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('report-detail')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }